import { FundingRequestEntity } from "modules/finances/entities";
import pages from "pages/_router";
import React, { CSSProperties } from "react";
import { FundingRequestDto } from "shared/api";
import { formatNumber, pluralize } from "shared/lib";
import { Empty, EntityHeader, IListData, List } from "shared/ui";
import styles from "./funding-request-list.module.scss";

export interface IFundingRequestList extends IListData<FundingRequestDto> {
  showTotal?: boolean;
  companySlug: string;

  className?: string;
  style?: CSSProperties;
  htmlId?: string;
}

export const FundingRequestList = (props: IFundingRequestList) => {
  return (
    <List
      {...props}
      renderItem={(it) => (
        <FundingRequestEntity
          data={it}
          companySlug={props.companySlug}
          href={pages.company(props.companySlug).finances.fundingRequests.id(it.id).href}
        />
      )}
      header={
        <EntityHeader>
          <div className={styles.left}>
            Всего{" "}
            {pluralize(props.data?.length, {
              one: (it) => `${it} заявка`,
              few: (it) => `${it} заявки`,
              many: (it) => `${it} заявок`,
            })}
          </div>
          {props.showTotal && (
            <div className={styles.right}>
              <div className={styles.item}>
                <div className={styles.label}>Запрошено:</div>
                <div className={styles.value}>
                  {formatNumber(props.data?.map((it) => Number(it.amount)).reduce((a, b) => a + b, 0))}
                </div>
              </div>
              <div className={styles.item}>
                <div className={styles.label}>Резерв:</div>
                <div className={styles.value}>
                  {formatNumber(
                    props.data
                      ?.map((it) => Number(it.approvedAmount) - Number(it.paidAmount))
                      .reduce((a, b) => a + b, 0)
                  )}
                </div>
              </div>
            </div>
          )}
        </EntityHeader>
      }
      empty={props.empty || <Empty title="Нет заявок" />}
    />
  );
};

FundingRequestList.defaultProps = {};
